import { Store } from '@src/application/store/store';
import { StateDefinition } from '@src/application/store/state-definition';
import { LegacyStore } from '@src/application/store/legacy-store-interface.js';

const store = new Store({
    clientId: new StateDefinition(null, 'clientId'),
});
export default store as unknown as LegacyStore<string|null>;
